module.exports = __webpack_public_path__ + "static/media/353.de63e162.svg";